import { render, staticRenderFns } from "./FieldsHistory.vue?vue&type=template&id=d341a970&scoped=true&"
import script from "./FieldsHistory.vue?vue&type=script&lang=js&"
export * from "./FieldsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d341a970",
  null
  
)

export default component.exports